import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GoToActions } from "src/pageDefinitions/types";

export type GlobalExitConfig = {
  enabled?: boolean;
  exitAction?: GoToActions;
};

const initialState: GlobalExitConfig = {
  enabled: false,
  exitAction: undefined,
};

const globalExitConfigurationSlice = createSlice({
  name: "globalExitConfiguration",
  initialState,
  reducers: {
    setGlobalExitAction(state, action: PayloadAction<GoToActions>) {
      return {
        enabled: true,
        exitAction: action.payload,
      };
    },
    clearGlobalExitAction() {
      return { enabled: false };
    },
  },
});

export const { setGlobalExitAction, clearGlobalExitAction } =
  globalExitConfigurationSlice.actions;

export default globalExitConfigurationSlice;
